export default function PricingTable() {
  const scrollToForm = () => {
    const formSection = document.getElementById('contact-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const packages = [
    {
      title: 'Xe 5–8 chỗ',
      subtitle: 'Driver Guide tiếng Việt',
      price: '10 triệu VNĐ/ngày',
      image: 'https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/f9b3baf7dc9f6d378cf6e458bdf2656e.jpeg',
      features: [
        'Phù hợp gia đình – nhóm nhỏ – Free & Easy – thăm thân',
        'Xe đời mới: Toyota Sienna, Honda Odyssey, SUV',
        'Lái xe + hướng dẫn viên tiếng Việt',
        'Nội thất cao cấp, rộng rãi'
      ],
      popular: false
    },
    {
      title: 'Xe 12–15 chỗ',
      subtitle: 'Có lái xe riêng',
      price: '15 triệu VNĐ/ngày',
      image: 'https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/dd2459e9e70543d4a45a851c6d935dc2.jpeg',
      features: [
        'Thích hợp đoàn nhỏ – trường học – trại hè – du học',
        'Xe mini bus đời mới',
        'Lái xe chuyên nghiệp có kinh nghiệm',
        'Khoang hành lý rộng rãi'
      ],
      popular: false
    },
    {
      title: 'Xe 36 chỗ',
      subtitle: 'Có lái xe riêng',
      price: '18 triệu VNĐ/ngày',
      image: 'https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/2cb49b77091eaa415ca54376614039a0.jpeg',
      features: [
        'Phù hợp đoàn trung bình – công ty – tổ chức',
        'Xe Coach đời mới, tiện nghi đầy đủ',
        'Lái xe chuyên nghiệp có kinh nghiệm',
        'Khoang hành lý rộng rãi'
      ],
      popular: true
    },
    {
      title: 'Xe 56 chỗ',
      subtitle: 'Có lái xe riêng',
      price: '20 triệu VNĐ/ngày',
      image: 'https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/b73f81c22cf10d0102159288ad34c10f.jpeg',
      features: [
        'Dành cho công ty du lịch Việt Nam có đoàn lớn',
        'Xe Coach chuẩn Mỹ – nội thất rộng',
        'Khoang hành lý lớn',
        'Tiện nghi đầy đủ cho hành trình dài'
      ],
      popular: false
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Bảng Dịch Vụ &amp; Báo Giá Cơ Bản
          </h2>
          <p className="text-lg sm:text-xl text-gray-700 max-w-3xl mx-auto font-medium">
            Chọn loại xe phù hợp với nhu cầu của đoàn bạn
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-12">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 ${
                pkg.popular ? 'border-red-600' : 'border-gray-200'
              }`}
            >
              {pkg.popular && (
                <div className="absolute top-0 right-0 bg-red-600 text-white px-4 sm:px-6 py-2 text-sm sm:text-base font-bold z-10">
                  PHỔ BIẾN NHẤT
                </div>
              )}

              <div className="h-48 sm:h-64 overflow-hidden">
                <img
                  src={pkg.image}
                  alt={pkg.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="p-6 sm:p-8">
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                  {pkg.title}
                </h3>
                <p className="text-base sm:text-lg text-blue-900 font-bold mb-4">
                  {pkg.subtitle}
                </p>

                <div className="mb-6">
                  <p className="text-sm sm:text-base text-gray-700 mb-1 font-semibold">Giá chỉ từ</p>
                  <p className="text-2xl sm:text-3xl font-bold text-red-600">
                    {pkg.price}
                  </p>
                </div>

                <ul className="space-y-3 mb-8">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-green-600 text-xl sm:text-2xl mr-3 flex-shrink-0 mt-0.5"></i>
                      <span className="text-base sm:text-lg text-gray-800 font-medium">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={scrollToForm}
            className="whitespace-nowrap bg-orange-600 hover:bg-orange-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-bold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            <i className="ri-file-text-line mr-2 text-lg sm:text-xl"></i>
            Nhận bảng giá đầy đủ
          </button>
        </div>
      </div>
    </section>
  );
}